import { Fee, TxType } from "../shared";
import { CefiInfoTx, DefiInfoTx } from "../untrustedApi";
import z from "zod";

export type PureCefiInfoTx = Omit<CefiInfoTx, "account"> & {
  exchangeAccount: ExchangeAccount;
};

export type ExchangeAccount = {
  exchangeId: string;
  exchangeInstanceId: string; // hash of the cexId and the public API key
};

export type PureTransaction<T = PureCefiInfoTx | DefiInfoTx, U = PureCefiInfoTx | DefiInfoTx> = {
  from: T;
  to: U;
  type: TxType;
};

export function isPureCefiInfoTx(tx: PureCefiInfoTx | DefiInfoTx): tx is PureCefiInfoTx {
  return "wallet" in tx;
}

export type GetWithdrawalFeeReturn = Omit<Partial<Fee>, "refAmount">;

export const KrakenWithdrawalMethodDtoSchema = z.object({
  asset: z.string(),
  method: z.string(),
  method_id: z.string(),
  network: z.string(),
  network_id: z.string(),
  minimum: z.string(),
});

export type KrakenWithdrawalMethodDto = z.infer<typeof KrakenWithdrawalMethodDtoSchema>;
